import type { AudienceFilter } from '../types';

export interface FilteredAudienceForm {
  skillIds: number[];
  taxTypes: Array<'w2' | '1099'>;
  zipCode?: string;
  radiusMiles?: number;
}

export function buildFilteredAudience(
  form: FilteredAudienceForm,
): AudienceFilter {
  const filter: AudienceFilter = {
    mode: 'filtered',
    skills: form.skillIds,
    tax_types: form.taxTypes,
  };

  if (form.zipCode && form.radiusMiles) {
    filter.location = {
      zip_code: form.zipCode,
      radius_miles: form.radiusMiles,
    };
  }

  return filter;
}

export function buildDirectAudience(userIds: number[]): AudienceFilter {
  return { mode: 'direct', user_ids: userIds };
}
